import React from 'react';
import { Switch } from 'view/common';
import LINK from 'assets/img/link_pre.png';
import COPY from 'assets/img/copy.png';
import cx from 'classnames';
import './style.scss';

const Share = ({ onChange, shareEnabled, onCopy }) => (
  <div className="modalContent">
    <h1>Share this project</h1>
    <div className="switchContainer">
      <p>Enable sharing</p>
      <Switch checked={shareEnabled} onChange={onChange} />
    </div>
    <hr />
    <div className={cx('linkContainer', {
      inactive: !shareEnabled,
    })}
    >
      <img src={LINK} alt="link share" />
      <div className="link">
        <p>Share this project by using the link below:</p>
        <span>
          <a id="share-link" href="https://thisisthelinktheuserswillsharewiththepeopletheywant">
          https://thisisthelinktheuserswillsharewiththepeopletheywant
          </a>
          <img onClick={onCopy} src={COPY} alt="" />
        </span>
      </div>
    </div>
  </div>
);


export { Share };



// WEBPACK FOOTER //
// ./src/view/screens/ModalBodies/Share.js